import AdminPage from "@/pages/AdminPage";
import AdminPageMobile from "@/pages/admin/AdminPageMobile";
import { useIsMobile } from "@/hooks/useIsMobile";

/**
 * The /admin route.
 *
 * This used to be a hero: a 3xl heading, a paragraph of prose and a badge reading
 * "Runs on the restaurant's own server", stacked on top of a console that already
 * had its own sidebar and its own heading. Three levels of chrome — AppShell's
 * topbar, this hero, then the page title — before the first setting, on a screen
 * whose entire job is density (§2.2, §21). The breadcrumb inside AdminPage carries
 * "Administration" now, so the wrapper is the frame and nothing else.
 *
 * Devices below 768px CSS px (phones) get AdminPageMobile — a bottom-tab,
 * accordion-based redesign that does NOT touch the desktop AdminPage at all. The
 * two render the same data and share the same write path, so a setting changed on
 * the phone and on the desktop is indistinguishable server-side.
 */
export default function AdminHubPage() {
  const isMobile = useIsMobile(767);
  return (
    <div className="h-full overflow-hidden bg-background" data-testid="enterprise-admin-page">
      {isMobile ? <AdminPageMobile /> : <AdminPage />}
    </div>
  );
}
